"use strict";

var React = require('react/addons');
var mixins = require('../mixins');
var Field = require('./field');

module.exports = React.createClass({
  mixins: [mixins.BackboneBindingMixin],

  render: function() {
    return (
      <Field label={this.props.label} model={this.props.model} field={this.props.field} name={this.props.name} error={this.props.error} adminOnly={this.props.adminOnly}>
        <input ref="input" type="text" valueLink={this.bindTo(this.props.model, this.props.field)} id={this.props.name} onBlur={this.props.onBlur ? this.props.onBlur : null} placeholder={this.props.placeholder}/>
      </Field>
    );
  }
});



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/react/fields/textfield.jsx
 **/